// extracted by mini-css-extract-plugin
var _1 = "z54ym";
var _2 = "wgz5a";
var _3 = "nkI5J";
export { _1 as "layout", _2 as "main", _3 as "single" }
